<template>
  <div class="fullscreen-wrapper" ref="fullscreenRef">
    <button class="fullscreen-btn" @click="toggleFullscreen">
      <svg v-if="!isFullscreen" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15 3h6v6M9 21H3v-6M21 15v6h-6M3 9V3h6"></path>
      </svg>
      <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 14h6v6M20 10h-6V4"></path>
      </svg>
    </button>

    <div class="action-area">
      <div class="left-panel">
        <div class="input-container">
          <label style="margin: 18px 0 0 0;" for="keyword-input">输入内容核心关键词</label>
          <span class="counter">{{ keywordCount }} / 50</span>
          <textarea
            required
            id="keyword-input"
            v-model="keywords"
            @input="updateCounter"
            placeholder="例如：介绍一款适合独居女性的极简风空气炸锅..."
            maxlength="50"
          ></textarea>
          <required-hint :is-show="keywordError" message="内容核心关键词不能为空" />
        </div>

        <div class="platform-section">
          <label>发布平台</label>
          <div class="platform-buttons">
            <button
              v-for="platform in platforms"
              :key="platform.id"
              :class="['platform-btn', { active: selectedPlatform === platform.id }]"
              @click="selectPlatform(platform.id)"
            >
              {{ platform.name }}
            </button>
          </div>
          <required-hint :is-show="keywordError1" message="请选择平台" />
        </div>

        <div class="input-container">
          <label for="style-input">生成风格（10字以内）</label>
          <span class="counter">{{ styleCount }} / 10</span>
          <input
            id="style-input"
            v-model="styleText"
            @input="updateStyleCounter"
            placeholder="例如：种草、干货、悬念..."
            maxlength="10"
          />
          <required-hint :is-show="keywordError2" message="请输入生成风格" />
        </div>

        <div class="input-container">
          <label for="people-input">人物画像（10字以内）</label>
          <span class="counter">{{ peopleCount }} / 10</span>
          <input
            id="people-input"
            v-model="peopleText"
            @input="updatePeopleCounter"
            placeholder="例如：学生党、宝妈、打工人..."
            maxlength="10"
          />
          <required-hint :is-show="keywordError3" message="请输入人物画像" />
        </div>

        <div class="panel-button">
          <button
            :disabled="isDisabled"
            :class="{ 'generate-btn--disabled': isDisabled }"
            class="generate-btn"
            @click="generateTitles"
          >
            {{ generateButtonTitle }}
          </button>
          <img @click="clearForm" class="delete-img-button" src="../assets/删除.png" alt="">
        </div>
      </div>

      <div class="right-panel">
        <div class="loading-overlay" v-if="isGenerating">
          <div class="loading-spinner"></div>
          <p>AI正在为你生成爆款标题...</p>
        </div>

        <img v-if="!isGenerating && generatedTitles.length == 0" src="../assets/loading.png" alt="AI生成预览">
        <p v-if="!isGenerating && !showResults" class="temp-p">
          请在左侧输入内容并点击"生成"按钮
          AI将为您实时创作 6 个爆款标题
        </p>

        <div v-else-if="!isGenerating && showResults" class="results-container">
          <div class="title-list">
            <div v-for="(title, index) in generatedTitles" :key="index" class="title-item">
              <div class="title-number">{{ index + 1 }}</div>
              <div class="title-info">
                <div class="title-content">{{ title.titleText }}</div>
                <div class="title-tags">{{ title.titleTab }}</div>
              </div>
              <button class="copy-btn" @click="copyTitleAndTag(title)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2"></path>
                </svg>
                复制
              </button>
            </div>
          </div>
        </div>

        <div class="right-panel-bottom" v-if="!isLogin">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 3a4 4 0 0 1 0 8H7a4 4 0 0 1 0-8"></path>
              <path d="M17 21a4 4 0 0 0 0-8H7a4 4 0 0 0 0 8"></path>
            </svg>
          </div>
          <div>
            <p class="login-title">登录后保存历史记录</p>
            <p class="login-desc">同步至移动端，随时随地查看生成记录</p>
          </div>
          <div>
            <router-link to="/login" class="login-now">立即登录</router-link>
          </div>
        </div>

        <div class="right-panel-bottom" v-else>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </div>
          <div>
            <p class="login-title">已登录，可查看历史记录</p>
            <p class="login-desc">所有生成记录都会安全保存在你的账号中</p>
          </div>
          <div>
            <button class="login-now" @click="goHistory">查看历史</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/auth'
import { formatDict } from '@/utils/common'
import { generateXhsTitlesTest } from '@/api/ai'
import RequiredHint from './RequiredHint.vue'

export default {
  name: 'TitleGenerator',
  components: { RequiredHint },
  data() {
    return {
      generateButtonTitle: '立即生成爆款标题',
      keywords: '介绍一款适合独居女性的极简风空气炸锅',
      keywordError: false,
      keywordError1: false,
      keywordError2: false,
      keywordError3: false,
      keywordCount: 0,
      styleText: '',
      styleCount: 0,
      peopleText: '',
      peopleCount: 0,
      selectedPlatform: '',
      showResults: false,
      generatedTitles: [],
      isDisabled: false,
      isGenerating: false,
      countdown: 0,
      timer: null,
      isFullscreen: false,
      platforms: [
        { id: 'xiaohongshu', name: '小红书' },
        { id: 'douyin', name: '抖音' },
        { id: 'kuaishou', name: '快手' },
        { id: 'gongzhonghao', name: '公众号' },
      ],
    }
  },
  computed: {
    isLogin() {
      return !!this.$store.getters.getToken;
    }
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
  },
  methods: {
    toggleFullscreen() {
      const el = this.$refs.fullscreenRef
      if (!el) return
      if (!this.isFullscreen) {
        if (el.requestFullscreen) el.requestFullscreen()
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen()
      } else {
        if (document.exitFullscreen) document.exitFullscreen()
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen()
      }
    },
    handleFullscreenChange() {
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement)
    },

    goHistory() {
      this.$topTip({
        message: '功能暂未开放',
        type: 'info'
      })
    },
    updateCounter() {
      this.keywordCount = this.keywords.length
    },
    updateStyleCounter() {
      this.styleCount = this.styleText.length
    },
    updatePeopleCounter() {
      this.peopleCount = this.peopleText.length
    },
    selectPlatform(platformId) {
      this.selectedPlatform = platformId
    },
    generateTitles() {
      if (!this.keywords.trim()) {
        this.keywordError = true
        return
      }
      if (this.selectedPlatform == '') {
        this.keywordError1 = true
        return
      }
      if (!this.styleText.trim()) {
        this.keywordError2 = true
        return
      }
      if (!this.peopleText.trim()) {
        this.keywordError3 = true
        return
      }

      this.generateButtonTitle = "正在生成"
      if (this.isDisabled) return
      this.isDisabled = true
      this.isGenerating = true
      this.doGenerateTitles()
    },
    async doGenerateTitles() {
      let data = {
        content: this.keywords,
        platform: formatDict(this.selectedPlatform, this.platforms),
        style: this.styleText,
        people: this.peopleText
      }

      try {
        const res = await generateXhsTitlesTest(data);
        if (res === 429) {
          this.$topTip({ message: '今日VIP次数已达上限，请明天再试', type: 'error' })
          return null
        }
        if (res === 430) {
          this.$topTip({ message: '会员过期', type: 'error' })
          const userInfo = await getUserInfo();
          this.$store.dispatch('setDailyInfo', { usage: userInfo.dailyUsage, limit: userInfo.dailyLimit })
          this.$store.dispatch('updateVipLevel', userInfo.user.vipLevel)
          return null
        }
        this.generatedTitles = res
        if (res && res.length) {
          this.$topTip({ message: '成功生成', type: 'success', duration: 1000 })
        } else {
          this.$topTip({ message: '生成失败，请重试', type: 'error' })
        }
      } catch (error) {
        this.$topTip({ message: '生成失败，请重试', type: 'error' })
      } finally {
        this.resetButton()
        this.isGenerating = false
      }
      this.keywordError = this.keywordError1 = this.keywordError2 = this.keywordError3 = false
      this.showResults = true
      this.keywords = this.styleText = this.peopleText = this.selectedPlatform = ''
    },
    clearForm() {
      this.keywords = ''
      this.styleText = ''
      this.peopleText = ''
      this.selectedPlatform = ''
      this.keywordCount = this.styleCount = this.peopleCount = 0
      this.keywordError = this.keywordError1 = this.keywordError2 = this.keywordError3 = false
      this.showResults = false
      this.generatedTitles = []
    },
    copyTitleAndTag(item) {
      const copyText = item.titleText + '\n' + item.titleTab
      const textArea = document.createElement('textarea')
      textArea.value = copyText
      document.body.appendChild(textArea)
      textArea.select()
      try {
        const suc = document.execCommand('copy')
        this.$topTip({ message: suc ? '复制成功' : '复制失败', type: suc ? 'success' : 'error' })
      } catch (e) {
        alert('复制失败，请手动复制')
      }
      document.body.removeChild(textArea)
    },
    resetButton() {
      clearInterval(this.timer)
      this.timer = null
      this.isDisabled = false
      this.countdown = 0
      this.generateButtonTitle = '立即生成爆款标题'
    }
  }
}
</script>

<style scoped>
.fullscreen-wrapper {
  position: relative;
  width: 100%;
}
.fullscreen-btn {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 9999;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: #64748b;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.fullscreen-btn:hover {
  border-color: #667eea;
  color: #667eea;
}

/* 核心：全屏居中 + 最大宽度限制 + 不拉伸 */
:fullscreen {
  overflow: auto !important;
  background: #f8f9ff !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
:-webkit-full-screen {
  overflow: auto !important;
  background: #f8f9ff !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
:fullscreen .action-area {
  max-width: 1400px;
  width: 90% !important;
  margin: 0 auto !important;
}
:-webkit-full-screen .action-area {
  max-width: 1400px;
  width: 90% !important;
  margin: 0 auto !important;
}

.action-area {
  display: flex;
  gap: 16px;
  min-height: 80vh;
  width: 100%;
  box-sizing: border-box;
}

.left-panel {
  flex: 1;
  min-width: 320px;
  background: #f8f9ff;
  border: 2px dashed #d1d8ff;
  border-radius: 12px;
  padding: 20px 16px;
  box-sizing: border-box;
}

.right-panel {
  flex: 2;
  min-width: 500px;
  background: #f8f9ff;
  border: 2px dashed #d1d8ff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.right-panel img {
  width: 50%;
  max-width: 300px;
  min-width: 200px;
}

.temp-p {
  color: rgb(148 163 184);
  font-weight: 500;
  font-size: 16px;
  width: 80%;
  text-align: center;
  margin: 10px 0;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 12px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-overlay p {
  color: #64748b;
  font-size: 16px;
}

.input-container {
  margin-bottom: 16px;
}

.input-container label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #333;
}

.counter {
  float: right;
  font-size: 14px;
  color: #999;
}

.input-container textarea {
  width: 100%;
  height: 100px;
  padding: 12px;
  border: 1px solid #ffffff;
  border-radius: 8px;
  resize: none;
  font-size: 16px;
  color: #333;
  background: white;
  box-sizing: border-box;
}

.input-container input {
  width: 100%;
  padding: 12px;
  border: 1px solid #fff;
  border-radius: 8px;
  font-size: 16px;
  background: #fff;
  box-sizing: border-box;
}

.input-container textarea:focus,
.input-container input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.platform-section {
  margin-bottom: 16px;
}

.platform-section label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.platform-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.platform-btn {
  padding: 8px 14px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.platform-btn:hover {
  border-color: #667eea;
  color: #667eea;
}

.platform-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.panel-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}

.generate-btn {
  flex: 1;
  padding: 12px 18px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s;
}

.generate-btn:hover {
  transform: translateY(-2px);
}

.generate-btn--disabled,
.generate-btn:disabled {
  background: #cccccc !important;
  cursor: not-allowed;
  opacity: 0.6;
}

.delete-img-button {
  height: 44px;
  border-radius: 9999px;
  box-shadow: 1px 2px 8px #333;
  cursor: pointer;
  flex-shrink: 0;
}

.delete-img-button:hover {
  transform: translateY(-2px);
}

.right-panel-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 15px 0 0 0;
  width: 100%;
  border-top: 1px solid #e0e7ff;
  margin-top: auto;
}

.right-panel-bottom svg {
  border-radius: 50%;
  background-color: rgb(224 231 255);
  color: rgb(79 70 229);
  padding: 8px;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.login-title {
  color: rgb(51 65 85);
  font-weight: 700;
  font-size: 16px;
  margin: 0;
}

.login-desc {
  font-size: 14px;
  color: rgb(100 116 139);
  margin: 4px 0 0 0;
}

.login-now {
  color: rgb(79 70 229);
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  white-space: nowrap;
}

.results-container {
  width: 100%;
  margin-top: 20px;
}

.title-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.title-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: transform 0.2s, box-shadow 0.2s;
  min-width: 0;
}

.title-number {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.title-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.title-content {
  color: #1e293b;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 500;
  word-break: break-all;
}

.title-tags {
  font-size: 14px;
  color: #64748b;
}

.copy-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: #475569;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.copy-btn:hover {
  background: #e2e8f0;
  color: #334155;
}

@media (max-width: 768px) {
  .action-area {
    flex-direction: column;
    gap: 12px;
  }
  .left-panel {
    padding: 16px 12px;
    min-width: 100%;
  }
  .right-panel {
    padding: 14px;
    min-width: 100%;
  }
  .temp-p {
    width: 95%;
    font-size: 15px;
  }
  :fullscreen .action-area {
    width: 96% !important;
  }
  :fullscreen{
    display: block;
    padding: 5px;
  }
}
</style>